import React, { useEffect, useState } from "react";
import { useTreeContext } from "../../context/TreeDataContext";
import { useCronContext } from "../../context/CronContext";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../Layouts/Loader/Loader";
import { getFolderFileById } from "../../utils/treeData/folderEditorUtils";
import CronMainSection from "./CronSection/CronMainSection";
import ErrorMessage from "../../components/FormComponents/ErrorMessage";

const CronViewer = () => {
  const { cronExplorerData } = useTreeContext();
  const { selectedCron, setSelectedCron } = useCronContext();
  const [isLoading, setIsLoading] = useState(true);
  const { cronId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!cronExplorerData || selectedCron?.id === cronId) return;
    const file = getFolderFileById(cronExplorerData, cronId);
    if (file) {
      setSelectedCron({
        id: file.id,
        name: file.name,
        parentData: file.parentData
      });
      setIsLoading(false);
    } else {
      navigate("../");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cronId]);

  const renderCronContent = () => {
    switch (selectedCron?.parentData) {
      case "cron":
        return <CronMainSection file={selectedCron} />;
      default:
        return (
          <div className="d_flex justify_center align_center h_100">
            <ErrorMessage>Unsupported api template: {selectedCron.parentData}</ErrorMessage>
          </div>
        );
    }
  };

  return (
    <div className="w_100">
      {isLoading ? (
        <Loader />
      ) : (
        <div className="flex_column h_100">
          <div className="h_100">{renderCronContent()}</div>
        </div>
      )}
    </div>
  );
};

export default CronViewer;
